<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-copyright element-without-heading" epub:type="copyright-page" id="copyright">
<div class="text" id="copyright-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Copyright Page</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content"><b>Queen of Belize</b></p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Text copyright @ 2021 by Words to Ponder Publishing Company, LLC</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Cover Design by Woodson Creative Studio.</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">First Print</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">This book is protected under the copyright laws of the United States and other countries throughout the world. Although inspired by actual events, all names, characters, and incidents portrayed are fictitious. No identification with real persons (living or deceased), places, buildings, or products are intended or should be inferred.</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">All rights reserved. No part of this book, or the characters within it, may be reproduced or transmitted in any form or by any mechanical means, including information storage and retrieval systems, without written permission from the publisher, Words to Ponder Publishing Company, LLC, except by reviewer, who may quote passages in a review.</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Address inquiries to Words to Ponder Publishing Company, LLC</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">eBook ISBN: 978-7358795-8-1</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Trade Paperback ISBN: 978-1-941328-58-3</p>
</div>
</div>
<figure class="inline-image inline-image-kind-photograph inline-image-size-medium inline-image-flow-center inline-image-flow-within-text inline-image-aspect-square inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<img alt="" src="images/image1.png"/>
</div>
</figure>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Words to Ponder Publishing Company, LLC</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">Printed in the United States of America</p>
<p class="alignment-block-content alignment-block-content-center copyright-content">For more information, visit <a class="content-external-link text-is-url" href="https://www.florenza.org" target="_blank">https://<wbr/>www.<wbr/>florenza.org</a> or</p>
<p class="alignment-block-content alignment-block-content-center copyright-content"><a class="content-external-link" href="https://www.wordstoponderpublishing.com" target="_blank">https://www.wordstoponderpublishing.com.</a></p>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-chapter first-full-width copyright-content">I dedicate this book to my husband, best friend, and soulmate, my Papa Bear. To my children, Jessica, and Missy, who are my first and loudest cheerleaders. To family and friends, who are my most incredible supporters. To Naleighna Kai and the NK Tribe Called Success for taking me under your wing and teaching this bird to soar. To Stephanie M. Freeman, my “drink and two-step” partner in crime. To my editors, who take the broken pieces of my words and ensure they are woven together in such a fashion, they create an amazing literary tapestry. To the beta readers who dedicate countless hours to be the first set of eyes to partake of the deliciousness of this story. And to you, the reader, for your encouragement and support of the magnificent gift of writing given to me by God.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?d8a1a1f0